import React from "react";
import { Box, Skeleton } from "@mui/material";

const BAR_COUNT = 7;
const X_AXIS_HEIGHT = 8; // px

const GraphSkeleton = ({ height = 400 }) => {
  const barHeights = [0.6, 0.85, 0.4, 0.7, 0.95, 0.5, 0.8];

  return (
    <Box
      sx={{
        width: "100%",
        height,
        minHeight: 200,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        position: "relative",
        background: (theme) => theme.palette.background.paper,
        borderRadius: 2,
        px: { xs: 1, sm: 3 },
        py: { xs: 1, sm: 2 },
      }}
    >
      {/* Bars */}
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          height: `calc(100% - ${X_AXIS_HEIGHT}px)`,
          gap: { xs: 0.5, sm: 2 },
          zIndex: 1,
        }}
      >
        {barHeights.map((h, idx) => (
          <Skeleton
            key={idx}
            variant="rectangular"
            height={`calc(${h * 100}% )`}
            animation="wave"
            sx={{
              borderRadius: 1,
              bgcolor: "grey.200",
              boxShadow: 1,
              flex: 1,
              minWidth: 0,
            }}
          />
        ))}
      </Box>
      {/* X-axis */}
      <Box
        sx={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          height: X_AXIS_HEIGHT,
          bgcolor: "grey.300",
          borderRadius: 1,
        }}
      />
      {/* Simulated X-axis labels */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          position: "absolute",
          left: { xs: 8, sm: 24 },
          right: { xs: 8, sm: 24 },
          bottom: X_AXIS_HEIGHT,
          zIndex: 2,
        }}
      >
        {Array.from({ length: BAR_COUNT }).map((_, idx) => (
          <Skeleton key={idx} variant="text" width={{ xs: 18, sm: 24 }} height={16} sx={{ bgcolor: "grey.100" }} />
        ))}
      </Box>
      {/* Simulated Y-axis label */}
      <Skeleton
        variant="text"
        width={{ xs: 28, sm: 40 }}
        height={20}
        sx={{
          position: "absolute",
          left: 0,
          top: 16,
          bgcolor: "grey.100",
        }}
      />
    </Box>
  );
};

export default GraphSkeleton;
